import type { Branch } from '@wix/ambassador-editor-branches-v1-branch/types';

export class SiteBranches {
  private branchesData: Branch[] = [];

  constructor(branches: Branch[]) {
    this.branchesData = branches;
  }

  get isEmpty(): boolean {
    return this.branchesData.length === 0;
  }

  get hasBranches(): boolean {
    return this.branchesData.length > 0;
  }

  get branches(): Branch[] {
    return this.branchesData;
  }
}
